import Vue from 'vue'
import App from './App.vue'

import 'bootstrap';

new Vue({
  render: h => h(App),
}).$mount('#app')
